import { RegisterScreenNavigationProps } from "./types"
import React from "react"
import { useTheme } from '~/ui/styled'
import Register from "./register-screen"
import { PageRoot } from "~screens/page-root"


const RegisterScreen: React.FC<RegisterScreenNavigationProps> = () => {
  const theme = useTheme()
  return (
    <PageRoot $background={theme.colors.primary}>
      <Register />
    </PageRoot>
  )
}

export default RegisterScreen
